import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ShopProvider } from "@/context/ShopContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Boutique from "@/pages/Boutique";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Tracking from "@/pages/Tracking";
import Quiz from "@/pages/Quiz";
import Compare from "@/pages/Compare";
import Favorites from "@/pages/Favorites";
import Loyalty from "@/pages/Loyalty";
import Brand from "@/pages/Brand";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ShopProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-[#FAF8F5] text-[#1A1714]">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/boutique" element={<Boutique />} />
            <Route path="/parfum/:id" element={<ProductDetail />} />
            <Route path="/panier" element={<Cart />} />
            <Route path="/suivi" element={<Tracking />} />
            <Route path="/trouver-mon-parfum" element={<Quiz />} />
            <Route path="/comparer" element={<Compare />} />
            <Route path="/favoris" element={<Favorites />} />
            <Route path="/fidelite" element={<Loyalty />} />
            <Route path="/marque/:brand" element={<Brand />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </ShopProvider>
  );
}

export default App;
